import { memo } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsEyeFill } from 'react-icons/bs';
import { Button } from 'ypf-pas-general-ui-components';
import { useParams } from 'react-router-dom';

import PartJobLine from '../PartJobLine/PartJobLine';
import './Group.scss';
import BoxesWithText from '../../../MonthlyServiceRequest/BoxesWithText/BoxesWithText';
import useDetailsEventsModal from '../../../../hooks/useDetailsEventsModal';

const Group = (props) => {
  const {
    firstRowIndex,
    lastRowIndex,
    numberOfLines,
    tipoEvento,
    nombreEquipo,
    rowIndex,
    // if the group is Ubications, the following props are required
    ubicationName,
    ubicationFinished,
    // if the group is PartJobLine, the following props are required
    nameLine,
    namePosition,
    numberLine,
    numberPosition,
    unitMeasurement,
    hasTechnicalLocations,
    ubicationsData,
    lineBlockedBySap
  } = props;

  const {
    handleHasTechnicalLocations,
    handleShowDetailsEventsModal,
    handleOperations,
    handleTitleModal
  } = useDetailsEventsModal();
  const { id } = useParams();
  const arrayData = [
    {
      label: `${ubicationName} ${ubicationFinished ? ' (Serv. Finalizado)' : ''}`,
      className: 'ubication-label'
    },
    { label: tipoEvento },
    { label: nombreEquipo, className: ' ubication-label' }
  ];

  const midleIndex =
    numberOfLines === 1
      ? firstRowIndex
      : firstRowIndex + Math.round((lastRowIndex - firstRowIndex) / 2);

  const handleSetTitleModal = () => {
    handleTitleModal({
      title: `${ubicationName}${'  '}${tipoEvento}${'  '}${nombreEquipo}`
    });
  };

  return (
    <div className="group">
      {rowIndex === midleIndex ? (
        <>
          {ubicationName ? (
            <div
              className={`${rowIndex === firstRowIndex ? 'first-row-column' : ''} ${
                rowIndex === lastRowIndex ? 'last-row' : ''
              }`}
            >
              <div className="content-label-group">
                {arrayData.map(({ label, className, backgroundColor }) => (
                  <BoxesWithText
                    backgroundColor={backgroundColor}
                    className={className}
                    key={label}
                  >
                    <OverlayTrigger
                      key="top"
                      overlay={<Tooltip id="button-tooltip">{label}</Tooltip>}
                      placement="top"
                    >
                      <span className={className}>{label}</span>
                    </OverlayTrigger>
                  </BoxesWithText>
                ))}
              </div>
              <div className="d-flex">
                {handleHasTechnicalLocations({
                  headData: { tieneUbicacionesTecnicas: hasTechnicalLocations }
                }) && (
                  <Button
                    className="eye-button-left"
                    colorIcon="primary"
                    icon={BsEyeFill}
                    onClick={() => {
                      handleSetTitleModal();
                      handleShowDetailsEventsModal({ showModal: true });
                      handleOperations({
                        ubicationsData: { id: ubicationsData.ubicationId },
                        requestData: { nroSolicitud: id }
                      });
                    }}
                    sizeIcon="20px"
                    type="button"
                    widthButton="40px"
                  />
                )}
              </div>
            </div>
          ) : (
            <PartJobLine
              backgroundColorLine="#DDDDDD"
              backgroundColorPosition="#DDDDDD"
              backgroundUnitMeasurement="#DDDDDD"
              colorLine="#000000"
              colorPostion="#000000"
              colorUnitMeasurement="#000000"
              lineBlockedBySap={lineBlockedBySap}
              nameLine={nameLine}
              namePosition={namePosition}
              numberLine={numberLine}
              numberPosition={numberPosition}
              orderByPosition
              unitMeasurement={unitMeasurement}
            />
          )}
        </>
      ) : (
        <div
          className={`${rowIndex === firstRowIndex ? 'first-row-column' : ''} ${
            rowIndex === lastRowIndex ? 'last-row' : ''
          }`}
        />
      )}
    </div>
  );
};

Group.propTypes = {
  nameLine: PropTypes.string,
  namePosition: PropTypes.string,
  numberLine: PropTypes.number,
  numberPosition: PropTypes.number,
  unitMeasurement: PropTypes.string,
  firstRowIndex: PropTypes.number.isRequired,
  lastRowIndex: PropTypes.number.isRequired,
  numberOfLines: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired,
  ubicationName: PropTypes.string,
  tipoEvento: PropTypes.string,
  nombreEquipo: PropTypes.string,
  hasTechnicalLocations: PropTypes.bool.isRequired,
  ubicationsData: PropTypes.shape({ ubicationId: PropTypes.number }).isRequired,
  ubicationFinished: PropTypes.bool.isRequired,
  lineBlockedBySap: PropTypes.bool.isRequired
};

Group.defaultProps = {
  ubicationName: '',
  nameLine: '',
  namePosition: '',
  numberLine: null,
  numberPosition: null,
  unitMeasurement: '',
  tipoEvento: '',
  nombreEquipo: ''
};

export default memo(Group);
